<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <form name="ConfirmationForm" #ConfirmationForm="ngForm" (ngSubmit)="Validate(ConfirmationForm)">
        <div class="card-header">
            Confirmation Form
        </div>
        <div class="card-body p-0 m-2">
            <div class="row" style="--bs-gutter-x: 0">
                <div class="col-md-12" *ngFor="let Data of Datas; let i = index">
                    <span class="text-label-dark16500">{{Data.QuestionGroupName}}</span>
                    <div class="row my-2" style="--bs-gutter-x: 0">
                        <div class="col-md-2">
                            <span class="text-label">Question {{i + 1}}:</span>
                        </div>
                        <div class="col-md-6">
                            <span class="text-label">{{Data.Questions}}</span> 
                            <span class="text-label-light" *ngIf="common.ToLowerCase(Data.AnswerIsText) == 's'">(1 Being Lowest & 5 Being Highest)</span>
                        </div>
                    </div>
                    <div class="row" style="--bs-gutter-x: 0">
                        <div class="col-md-2">
                            <span class="text-label">Answer:</span>
                        </div>
                        <div class="col-md-6" *ngIf="common.ToLowerCase(Data.AnswerIsText) == 't'">
                            <textarea rows=2 class="form-control" name="answer{{i}}" [(ngModel)]="Data.answer"
                                #answer{{i}}="ngModel" required></textarea>
                            <div class="invalid-feedback">
                                Please enter answer !
                            </div>
                        </div>
                        <div class="col-md-2" *ngIf="common.ToLowerCase(Data.AnswerIsText) == 's'">
                            <input name="rating{{i}}" type="text" [(ngModel)]="Data.Score" class="form-control"
                                minlength="1" maxlength="1" placeholder="Rating" required 
                                onkeypress="return event.charCode >= 49 && event.charCode <= 53" />
                            <div class="invalid-feedback">
                                Please enter rating between 1 to 5 !
                            </div>
                        </div>
                        <div class="col-md-4 ms-2 text-center" *ngIf="common.ToLowerCase(Data.AnswerIsText) == 's'">
                            <span class="mandatory-field text-label">Rating between 1 to 5</span>
                        </div>
                    </div>
                    <hr />
                </div>
                <div class="col-md-12">
                    <div class="row" style="--bs-gutter-x: 0">
                        <div class="col-md-2">
                            <span class="text-label">Remark:</span>
                        </div>
                        <div class="col-md-6">
                            <textarea rows=2 class="form-control" name="Remark" [(ngModel)]="Filter.Remark"
                                #Remark="ngModel" required></textarea>
                            <div class="invalid-feedback">
                                Please enter remark !
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="Cancel()"><i
                        class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Submit':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>